export default __webpack_public_path__ + "static/media/photo2.c462f5b2.png";